import { PathTemplate } from '@notino/shared/definitions/types';

// needed for wishlist -> pd spa redirect
const pdSkeletonPrefixes = ['pd.about', 'pd.code', 'pd.availability'];

export const prefixes = {
  [PathTemplate.ProductDetailSimple]: [
    'pd',
    'attribute',
    'universals',
    'product',
    'brand',
    'reviews',
    'rating',
    'order',
    'relatedProducts',
    'global',
    'engraving',
    'try.it.first',
    'watchdog',
    'modiface',
    'wishlist',
    'productCard',
  ],
  [PathTemplate.Error]: ['pd'],
  [PathTemplate.Wishlist]: [
    'wishlist',
    'universals',
    'attribute',
    'reviews',
    'product',
    'pd.summer.black.friday',
    'pd.black.friday',
    'pd.common',
    'watchdog',
    'productCard',
    'global',
    ...pdSkeletonPrefixes,
  ],
  [PathTemplate.ReviewsPage]: [
    'pd.reviews',
    'pd.ratings',
    'pd.sortFilterBar',
    'pd.discount',
    'pd.main',
    'pd.expandableText',
    'reviews',
    'rating',
    'order',
    'global',
    'universals',
    'attribute',
    'product.item.discount',
  ],
};
